webpackJsonp([169315112914517],{

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    position: relative;\n    padding: ", ";\n    background-color: ", ";\n    color: ", ";\n    text-align: ", ";\n    font-size: ", "em;\n"], ["\n    position: relative;\n    padding: ", ";\n    background-color: ", ";\n    color: ", ";\n    text-align: ", ";\n    font-size: ", "em;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionContainer = _styledComponents2.default.section(_templateObject, function (props) {
	    return props.padding;
	}, function (props) {
	    return props.background;
	}, function (props) {
	    return props.color;
	}, function (props) {
	    return props.textAlign;
	}, function (props) {
	    return props.fontSize;
	});
	
	SectionContainer.propTypes = {
	    padding: _propTypes2.default.string,
	    background: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    textAlign: _propTypes2.default.string,
	    fontSize: _propTypes2.default.number
	};
	
	SectionContainer.defaultProps = {
	    padding: "2rem 0rem",
	    background: _theme.colors.background,
	    color: _theme.colors.white,
	    textAlign: "left",
	    fontSize: 1
	};
	
	exports.default = SectionContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    border: 1px solid #ddd;\n    overflow: hidden;\n"], ["\n    border: 1px solid #ddd;\n    overflow: hidden;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    font-size: 1.2em;\n    margin-bottom: 0;\n"], ["\n    font-size: 1.2em;\n    margin-bottom: 0;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    padding: ", "rem;\n    border-bottom: 1px solid #ddd;\n    display: table;\n    width: 100%;\n    transition: all 500ms ease-out;\n    &:hover {\n        background-color: rgba(7, 23, 44, 0.1);\n    }\n"], ["\n    padding: ", "rem;\n    border-bottom: 1px solid #ddd;\n    display: table;\n    width: 100%;\n    transition: all 500ms ease-out;\n    &:hover {\n        background-color: rgba(7, 23, 44, 0.1);\n    }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    padding: ", "rem ", "rem\n        ", "rem ", "rem;\n    border-bottom: none;\n"], ["\n    width: 100%;\n    padding: ", "rem ", "rem\n        ", "rem ", "rem;\n    border-bottom: none;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    display: table-cell;\n    vertical-align: middle;\n"], ["\n    display: table-cell;\n    vertical-align: middle;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    font-size: 1.2em;\n    font-weight: bold;\n    color: ", ";\n    margin-right: ", "rem;\n"], ["\n    font-size: 1.2em;\n    font-weight: bold;\n    color: ", ";\n    margin-right: ", "rem;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    font-weight: normal;\n    color: ", ";\n    font-size: 1rem;\n    line-height: 1.5;\n"], ["\n    font-weight: normal;\n    color: ", ";\n    font-size: 1rem;\n    line-height: 1.5;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactCustomScrollbars = __webpack_require__(106);
	
	var _reactCustomScrollbars2 = _interopRequireDefault(_reactCustomScrollbars);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = (0, _styledComponents2.default)(_reactCustomScrollbars2.default).attrs({ autoHide: true })(_templateObject);
	
	var Title = _styledComponents2.default.h1(_templateObject2);
	
	var Section = _styledComponents2.default.div(_templateObject3, _theme.spacing.padding);
	
	var TitleSection = _styledComponents2.default.div(_templateObject4, _theme.spacing.padding, _theme.spacing.padding, _theme.spacing.padding / 2, _theme.spacing.padding);
	
	var SectionDivider = _styledComponents2.default.div(_templateObject5);
	
	var NumberPrefix = _styledComponents2.default.div(_templateObject6, _theme.colors.lightGray, _theme.spacing.padding);
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject7, _theme.colors.black);
	
	var NewsPlaceholder = function NewsPlaceholder(_ref) {
	    var height = _ref.height,
	        news = _ref.news;
	    return _react2.default.createElement(
	        Container,
	        {
	            color: _theme.colors.background,
	            background: _theme.colors.white,
	            padding: _theme.spacing.padding + "rem ",
	            fontSize: 1,
	            style: { height: height + "rem", marginBottom: _theme.spacing.margin + "em" } },
	        console.log(news),
	        _react2.default.createElement(
	            TitleSection,
	            null,
	            _react2.default.createElement(
	                Title,
	                null,
	                "Featured Stories"
	            )
	        ),
	        news.map(function (_ref2, index) {
	            var item = _ref2.node;
	
	            return _react2.default.createElement(
	                StyledLink,
	                { to: item.fields.slug },
	                _react2.default.createElement(
	                    Section,
	                    null,
	                    _react2.default.createElement(
	                        SectionDivider,
	                        null,
	                        item.frontmatter.title
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = NewsPlaceholder;
	module.exports = exports["default"];

/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    margin: 2rem 0;\n"], ["\n    margin: 2rem 0;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _SectionContainer = __webpack_require__(92);
	
	var _SectionContainer2 = _interopRequireDefault(_SectionContainer);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledP = _styledComponents2.default.p(_templateObject);
	
	var PeoplePlaceholder = function PeoplePlaceholder(_ref) {
	    var height = _ref.height;
	    return _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	            color: _theme.colors.white,
	            background: _theme.colors.accent,
	            padding: _theme.spacing.padding + "rem ",
	            fontSize: 1,
	            style: { height: height + "rem", marginBottom: _theme.spacing.margin + "em" }
	        },
	        _react2.default.createElement(
	            _HeaderBlock2.default,
	            {
	                textAlign: "left",
	                accentColor: _theme.colors.background,
	                baseColor: _theme.colors.white,
	                fontSize: 3.1,
	                padding: {
	                    top: 0,
	                    left: 0,
	                    right: 0,
	                    bottom: 0
	                }
	            },
	            _react2.default.createElement(
	                "span",
	                null,
	                "People"
	            ),
	            " at our Core"
	        ),
	        _react2.default.createElement(
	            StyledP,
	            null,
	            "We deliver fresh thinking and innovative ideas that give our clients the edge over their competitors. Our passion and drive to know your business inside out and back to front enables us to work alongside you and become an inseparable extension of your marketing team."
	        ),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/people" },
	            _react2.default.createElement(
	                _rlaComponents.Button,
	                {
	                    hollow: true,
	                    size: "large",
	                    color: "white",
	                    borderWidth: 3,
	                    padding: 2
	                },
	                "Check Us Out \u2192"
	            )
	        )
	    );
	};
	
	exports.default = PeoplePlaceholder;
	module.exports = exports["default"];

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    height: ", "em;\n    position: relative;\n    background-image: url('", "');\n    background-size: cover;\n    background-position: center;\n    margin-bottom: ", "em;\n"], ["\n    height: ", "em;\n    position: relative;\n    background-image: url('", "');\n    background-size: cover;\n    background-position: center;\n    margin-bottom: ", "em;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: ", ";\n"], ["\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    max-width: 90%;\n    padding: ", "em;\n    color: ", ";\n    font-weight: bold;\n    a {\n        color: ", ";\n        text-decoration: underline;\n    }\n    ", ";\n"], ["\n    max-width: 90%;\n    padding: ", "em;\n    color: ", ";\n    font-weight: bold;\n    a {\n        color: ", ";\n        text-decoration: underline;\n    }\n    ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            transform: translate(-50%, -50%);\n            text-align: center;\n        "], ["\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            transform: translate(-50%, -50%);\n            text-align: center;\n        "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    padding: 0.6rem 0.8rem;\n    color: ", ";\n    margin-bottom: 2rem;\n    background: ", ";\n    font-size: 0.8rem;\n"], ["\n    display: inline-block;\n    padding: 0.6rem 0.8rem;\n    color: ", ";\n    margin-bottom: 2rem;\n    background: ", ";\n    font-size: 0.8rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    margin-top: 0;\n    color: ", ";\n    font-weight: 700;\n    font-size: 1.2rem;\n    line-height: 1.2;\n"], ["\n    margin: 0;\n    margin-top: 0;\n    color: ", ";\n    font-weight: 700;\n    font-size: 1.2rem;\n    line-height: 1.2;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _image = __webpack_require__(44);
	
	var _theme = __webpack_require__(6);
	
	var _helpers = __webpack_require__(12);
	
	var _Content = __webpack_require__(35);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.section(_templateObject, function (props) {
	    return props.height;
	}, function (props) {
	    return props.backgroundImage;
	}, _theme.spacing.margin);
	
	var Overlay = _styledComponents2.default.div(_templateObject2, (0, _helpers.transparentize)("#000000", 0.3));
	
	var TitleContainer = _styledComponents2.default.div(_templateObject3, _theme.spacing.padding, function (props) {
	    return props.theme.lightColor;
	}, function (props) {
	    return props.theme.lightColor;
	}, function (props) {
	    return props.centred && (0, _styledComponents.css)(_templateObject4);
	});
	
	var Category = _styledComponents2.default.h5(_templateObject5, function (props) {
	    return props.theme.lightColor;
	}, function (props) {
	    return props.theme.accent;
	});
	
	var Title = _styledComponents2.default.p(_templateObject6, function (props) {
	    return props.theme.lightColor;
	});
	
	var Wrapper = function Wrapper(_ref) {
	    var isFreelance = _ref.isFreelance,
	        href = _ref.href,
	        children = _ref.children;
	
	    if (isFreelance) {
	        return _react2.default.createElement(
	            "div",
	            null,
	            children
	        );
	    } else {
	        return _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: href },
	            children
	        );
	    }
	};
	
	var JobSummary = function JobSummary(_ref2) {
	    var job = _ref2.job,
	        height = _ref2.height,
	        centred = _ref2.centred;
	
	    var isFreelance = Boolean(job.frontmatter.area === "Freelance");
	    var href = job.frontmatter.description ? job.fields.slug : "/contact";
	
	    return _react2.default.createElement(
	        Wrapper,
	        { isFreelance: isFreelance, href: href },
	        _react2.default.createElement(
	            Container,
	            {
	                backgroundImage: (0, _image.getOriginalImageSrc)(job.frontmatter.hero),
	                height: height },
	            _react2.default.createElement(
	                Overlay,
	                null,
	                _react2.default.createElement(
	                    TitleContainer,
	                    { centred: centred },
	                    _react2.default.createElement(
	                        Category,
	                        null,
	                        job.frontmatter.area
	                    ),
	                    _react2.default.createElement(
	                        Title,
	                        null,
	                        job.frontmatter.title
	                    ),
	                    isFreelance && _react2.default.createElement(_Content2.default, { content: job.frontmatter.description })
	                )
	            )
	        )
	    );
	};
	
	exports.default = JobSummary;
	module.exports = exports["default"];

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    margin-top: 0em;\n"], ["\n    color: ", ";\n    margin-top: 0em;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _helpers = __webpack_require__(12);
	
	var _JobSummary = __webpack_require__(1131);
	
	var _JobSummary2 = _interopRequireDefault(_JobSummary);
	
	var _theme = __webpack_require__(6);
	
	var _People = __webpack_require__(1125);
	
	var _People2 = _interopRequireDefault(_People);
	
	var _News = __webpack_require__(1124);
	
	var _News2 = _interopRequireDefault(_News);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledButton = _rlaComponents.Button.extend(_templateObject, _theme.colors.background);
	
	var JobsSection = function (_React$Component) {
	    _inherits(JobsSection, _React$Component);
	
	    function JobsSection() {
	        _classCallCheck(this, JobsSection);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    JobsSection.prototype.render = function render() {
	        var _props = this.props,
	            jobs = _props.jobs,
	            news = _props.news;
	
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { medium: 6, large: 7, xlarge: 9, collapse: true },
	                    _react2.default.createElement(
	                        _rlaComponents.Row,
	                        { collapse: true },
	                        _react2.default.createElement(
	                            _rlaComponents.Column,
	                            null,
	                            _react2.default.createElement(_JobSummary2.default, {
	                                job: jobs[0].node,
	                                height: 36,
	                                centred: true
	                            })
	                        )
	                    ),
	                    (0, _helpers.isBrowser)() && !(0, _helpers.isMobile)() && _react2.default.createElement(
	                        _rlaComponents.Row,
	                        { collapse: true },
	                        _react2.default.createElement(
	                            _rlaComponents.Column,
	                            { large: 6, xlarge: 4 },
	                            _react2.default.createElement(_News2.default, {
	                                height: 37.5,
	                                news: news
	                            })
	                        ),
	                        _react2.default.createElement(
	                            _rlaComponents.Column,
	                            { large: 6, xlarge: 8 },
	                            jobs[2] && _react2.default.createElement(_JobSummary2.default, {
	                                job: jobs[2].node,
	                                height: 18
	                            }),
	                            jobs[3] && _react2.default.createElement(_JobSummary2.default, {
	                                job: jobs[3].node,
	                                height: 18
	                            })
	                        )
	                    ),
	                    (0, _helpers.isBrowser)() && (0, _helpers.isMobile)() && _react2.default.createElement(
	                        _rlaComponents.Row,
	                        { collapse: true },
	                        _react2.default.createElement(
	                            _rlaComponents.Column,
	                            null,
	                            jobs[2] && _react2.default.createElement(_JobSummary2.default, {
	                                job: jobs[2].node,
	                                height: 18
	                            }),
	                            jobs[3] && _react2.default.createElement(_JobSummary2.default, {
	                                job: jobs[3].node,
	                                height: 18
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { medium: 6, large: 5, xlarge: 3 },
	                    jobs[1] && _react2.default.createElement(_JobSummary2.default, { job: jobs[1].node, height: 18 }),
	                    _react2.default.createElement(_People2.default, { height: 36 }),
	                    jobs[4] && _react2.default.createElement(_JobSummary2.default, { job: jobs[4].node, height: 18 })
	                )
	            )
	        );
	    };
	
	    return JobsSection;
	}(_react2.default.Component);
	
	exports.default = JobsSection;
	module.exports = exports["default"];

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _helpers = __webpack_require__(12);
	
	var _theme = __webpack_require__(6);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _JobsSection = __webpack_require__(1132);
	
	var _JobsSection2 = _interopRequireDefault(_JobsSection);
	
	var _SectionContainer = __webpack_require__(92);
	
	var _SectionContainer2 = _interopRequireDefault(_SectionContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobPage = function (_React$Component) {
	    _inherits(JobPage, _React$Component);
	
	    function JobPage() {
	        _classCallCheck(this, JobPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    JobPage.prototype.render = function render() {
	        var _props = this.props,
	            data = _props.data,
	            transition = _props.transition;
	        var jobs = data.jobs.edges,
	            news = data.news.edges;
	
	        return _react2.default.createElement(
	            "div",
	            { style: transition && transition.style },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                { title: "Careers | RLA Group | Full Service Advertising Agency" },
	                _react2.default.createElement("meta", {
	                    name: "title",
	                    content: "Careers | RLA Group | Full Service Advertising Agency"
	                })
	            ),
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    null,
	                    _react2.default.createElement(
	                        _HeaderBlock2.default,
	                        {
	                            fontSize: _theme2.default.pageHeaderSection.fontSize,
	                            padding: _theme2.default.pageHeaderSection.padding },
	                        "Careers"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _SectionContainer2.default,
	                {
	                    color: _theme.colors.background,
	                    background: _theme.colors.white,
	                    padding: _theme.spacing.padding + "rem 0" },
	                _react2.default.createElement(_JobsSection2.default, { jobs: jobs, news: news })
	            )
	        );
	    };
	
	    return JobPage;
	}(_react2.default.Component);
	
	exports.default = JobPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-careers-js-639a71abd75381f3e5c2.js